import { render, staticRenderFns } from "./GroupAccordion.vue?vue&type=template&id=4901eaea&scoped=true&"
import script from "./GroupAccordion.vue?vue&type=script&lang=js&"
export * from "./GroupAccordion.vue?vue&type=script&lang=js&"
import style0 from "./GroupAccordion.vue?vue&type=style&index=0&id=4901eaea&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4901eaea",
  null
  
)

export default component.exports